import { render, staticRenderFns } from "./kalemarac.vue?vue&type=template&id=90a6bd4a&"
import script from "./kalemarac.vue?vue&type=script&lang=js&"
export * from "./kalemarac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports